import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Kontaktdaten } from '../../domain/model/kontaktdaten';
import { WestnetzKontaktdatenService } from '../../service/westnetz-kontaktdaten/westnetz-kontaktdaten.service';
import { TeilgebietSelectionService } from '../../service/common/teilgebiet/teilgebiet-selection.service';

@Component({
    selector: 'redispatch-contact-data-list',
    templateUrl: './contact-data-list.component.html',
    styleUrls: [
        './contact-data-list.component.scss',
    ],
    standalone: false,
})
export class ContactDataListComponent {

    public availableWestnetzKontaktdaten$: Observable<Kontaktdaten[]>;

    private kontaktdatenService = inject(WestnetzKontaktdatenService);
    private teilgebietSelectionService = inject(TeilgebietSelectionService);

    constructor() {
        this.availableWestnetzKontaktdaten$ = this.kontaktdatenService.listWestnetzKontaktdaten(
            this.teilgebietSelectionService.getSelectedStadtwerkeId(),
        );
    }

}
